













































































































import BaseItemsPage from "../BaseItemsPage";
import { PushDetailItem } from "@/store/push/statistic/types";
import { Component } from "vue-property-decorator";
import PushDetailFilter from "@/components/Push/Statistic/PushDetailFilter.vue";
import { ScrollButton } from "wings-ui-components";
import { Getter } from "vuex-class";
import { dateFilter } from "@/utils/date-util";
import { colorClassByStatus } from "@/utils/page-utils";

@Component({
  components: {PushDetailFilter, ScrollButton},
  filters: {dateFilter},
  methods: {colorClassByStatus},
})
export default class PushDetail extends BaseItemsPage<PushDetailItem> {

  @Getter("pushStatisticDetail") responseItems: any;
  @Getter("isLoadingDetailStat") isLoadingDetailStat!: boolean;

  is_show_filter = true;
  is_show_filter_additional = false;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      'create_date', 'application', 'recipient', 'partner',
      'os', 'message', 'status', 'detail',
    ];
  }

  getData() {
    return this.responseItems;
  }
}
